import React from 'react';
import SocialLinks from './SocialLinks';

const Hero: React.FC = () => {
  const roles = ['Operator', 'Designer', 'PM', 'Coach'];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-blush-100 via-sun-50 to-sky-100 pt-32 pb-20">
      {/* soft decorative blobs */}
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-blush-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-sky-200/40 blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 sm:px-10 lg:px-12">
        <div className="flex flex-col-reverse md:flex-row items-center gap-12">
          <div className="text-left flex-1">
            <div className="flex flex-wrap gap-2 mb-6">
              {roles.map((role) => (
                <span
                  key={role}
                  className="px-3 py-1 rounded-full bg-white/70 text-ink-600 text-sm font-semibold border border-white"
                >
                  {role}
                </span>
              ))}
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-ink-800 tracking-tight leading-[1.1] mb-5">
              Hi, I'm Sarah.
            </h1>

            <p className="text-xl md:text-2xl text-ink-600 leading-relaxed max-w-2xl mb-8">
              I build tech-enabled healthcare workflows to better care for those who need
              it most.
            </p>

            {/* Social Links */}
            <SocialLinks showTooltips className="space-x-5" />
          </div>

          {/* Headshot */}
          <div className="w-52 h-52 md:w-72 md:h-72 rounded-full overflow-hidden flex-shrink-0 ring-8 ring-white/60 shadow-xl">
            <img
              src="/SZ-headshot.jpg"
              alt="Sarah Zhou"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
